module.exports = __webpack_public_path__ + "static/media/gg_ak.4a5e3f0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/gg_ak.png
// module id = 425
// module chunks = 0